import {boldlyLog} from "../Utility/logging";
import {isEmpty, pick, reduce} from "lodash";
import {getStashedUser} from "../lib/userStash";

export function buildFullyLoadedEvent({sessionFacts={}} = {}) {

  let event = {
    event: 'fully_loaded',
    page_count: sessionFacts.pageCount,
  }

  let user = getStashedUser();

  if (user) {
    event.email_sha256 = user.email_sha256;
  }
  return event;
}

export function pushDataLayerEvent(event) {
  boldlyLog("pushing to data layer:", event)
  if (isEmpty(event))
    return false;

  window.dataLayer ||= [];
  window.dataLayer.push(event);
  return window.dataLayer;
}

export function getMergedDatalayer() {
  return reduce(window.dataLayer || [], (hash, item) => {
  //  console.log("ITEM: " + JSON.stringify(item, null, 2))
    if (item[0] === 'set') {
      hash[item[1]] = item[2];
    } else if (typeof item === 'object') {
      Object.assign(hash, item);
    } else {
      console.warn("no object: " + item);
    }
    return hash;
  }, {})
}
